import React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import { Tooltip } from "@mui/material";

export default function DropDownButton({
  style,
  btnTextStyle,

  btnIcon,
  iconPosition,
  btnName,
  clicked,
  disable = false,
  padding = false,
  isLoading = false,
  type = null,
}) {
  const cssClasses = {
    button: {
      padding: padding ? padding : "0.8rem 0.5rem",
      textAlign: "center",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      columnGap: "1rem",
    },
    buttonWrapper: {
      // border: '1px solid #D0D5DD',
      boxSizing: "border-box",
      boxShadow: style.boxShadow
        ? style.boxShadow
        : "0px 1px 2px rgba(16, 24, 40, 0.05)",
      borderRadius: "0.8rem",
      width: "100%",
      cursor: "pointer",
    },
    image: {
      display: "inline-block",
      verticalAlign: "middle",
      width: "2.4rem",
      height: "2.4rem",
      marginRight: "1rem",
      marginLeft: "1rem",
    },
    btnText: {
      fontWeight: "500",
      //   fontSize: "1.8rem",
      fontFamily: "Inter-Medium",
      //   lineHeight: "2.8rem",
      verticalAlign: "middle",
      display: "inline-block",
      margin: "0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textAlign: "left",
      textOverflow: "ellipsis",
    },
    loadingCircle: {
      width: "2.5rem",
      height: "2.5rem",
      color: "rgb(255, 255, 255)",
      marginLeft: "2rem",
    },
  };

  return (
    <button
      type={type}
      style={{
        ...cssClasses.buttonWrapper,
        color: style.color ? style.color : "#1570EF",
        backgroundColor: style.backgroundColor,
        opacity: disable ? "0.7" : "1",
        pointerEvents: disable ? "none" : "auto",
        border: style.border ? style.border : "1px solid #D0D5DD",
        fontSize: style.fontSize ? style.fontSize : "1.8rem",
        lineHeight: style.lineHeight ? style.lineHeight : "2.8rem",
        borderRadius: style.borderRadius ? style.borderRadius : "0.8rem",
        textDecorationLine: style.Line ? style.Line : "none",
        display: style.display ? style.display : "unset",
      }}
      onClick={clicked}
      tabIndex="0"
    >
      {btnIcon ? (
        iconPosition === "left" ? (
          <Tooltip title={<h1>{btnName}</h1>}>
            <div style={cssClasses.button}>
              {/* <img
              style={{ ...cssClasses.image, color: style.color }}
              src={btnIcon}
              alt={""}
            /> */}
              {btnIcon}
              <p
                style={{
                  ...cssClasses.btnText,
                  width: btnTextStyle?.width ? btnTextStyle?.width : "100%",
                }}
              >
                {btnName}
              </p>
              {isLoading && (
                <CircularProgress style={cssClasses.loadingCircle} />
              )}
            </div>
          </Tooltip>
        ) : (
          <Tooltip title={<h1>{btnName}</h1>}>
            <div style={cssClasses.button}>
              <p
                style={{
                  ...cssClasses.btnText,
                  width: btnTextStyle?.width ? btnTextStyle?.width : "100%",
                }}
              >
                {btnName}
              </p>
              {/* <img
              style={{ ...cssClasses.image, color: style.color }}
              src={btnIcon}
              alt={""}
            /> */}
              {btnIcon}
              {isLoading && (
                <CircularProgress style={cssClasses.loadingCircle} />
              )}
            </div>
          </Tooltip>
        )
      ) : (
        <Tooltip title={<h1>{btnName}</h1>}>
          <div style={cssClasses.button}>
            <p
              style={{
                ...cssClasses.btnText,
                width: btnTextStyle?.width ? btnTextStyle?.width : "100%",
              }}
            >
              {btnName}
            </p>
            {isLoading && <CircularProgress style={cssClasses.loadingCircle} />}
          </div>
        </Tooltip>
      )}
    </button>
  );
}
